(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Panoramax", [], factory);
	else if(typeof exports === 'object')
		exports["Panoramax"] = factory();
	else
		root["Panoramax"] = factory();
})(this, () => {
return 